var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalsettingsborder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    fill: "#FFF",
    cx: 19,
    cy: 19,
    r: 19
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 6.083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 16.771v1.523c0 .206.2.373.448.373.247 0 .447-.167.447-.373v-1.127h8.053v1.127c0 .206.2.373.448.373.247 0 .447-.167.447-.373v-1.127h8.054v1.127c0 .206.2.373.447.373s.448-.167.448-.373V16.77a.315.315 0 00-.123-.253.458.458 0 00-.306-.097h-8.52v-1.048c0-.206-.2-.373-.447-.373s-.448.167-.448.373v1.048h-8.52a.458.458 0 00-.305.097.315.315 0 00-.123.253z",
    stroke: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.292,
    cy: 22.625,
    r: 2.292
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 22.625,
    r: 2.292
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.708,
    cy: 22.625,
    r: 2.292
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.496 5.221c-.053 0-.115.04-.158.011-.43-.295-.682-.92-.589-1.42.01-.052.084-.062.122-.1a1.278 1.278 0 10-1.808-1.808c-.038.037-.048.111-.099.12-.5.092-1.125-.159-1.421-.59-.03-.042.01-.102.01-.155a1.279 1.279 0 00-2.556 0c0 .053.039.113.01.156-.296.43-.92.682-1.422.59-.05-.01-.06-.084-.098-.121A1.279 1.279 0 106.68 3.712c.038.038.112.048.122.1.092.5-.158 1.125-.589 1.42-.043.03-.105-.01-.159-.01a1.278 1.278 0 000 2.557c.055 0 .117-.041.16-.012.431.295.683.92.59 1.42-.01.052-.086.062-.124.101a1.279 1.279 0 001.808 1.808c.039-.039.05-.115.102-.125.5-.094 1.124.158 1.419.588.03.044-.011.107-.011.163a1.278 1.278 0 102.557 0c0-.056-.042-.119-.012-.163.295-.43.92-.681 1.419-.588.053.01.063.086.102.125a1.279 1.279 0 001.808-1.808c-.039-.039-.114-.05-.124-.102-.093-.5.159-1.124.59-1.419.043-.03.105.012.16.012a1.278 1.278 0 100-2.558zm-5.124 3.973a2.597 2.597 0 110-5.194 2.597 2.597 0 010 5.194z",
    fillRule: "nonzero"
  })))));
}
export default SvgGlobalsettingsborder;